import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogContentText,
  Typography,
  Stack,
  Zoom,
} from "@mui/material";
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { IconEye, IconEyeOff, IconSquareRoundedX } from "@tabler/icons-react";

const PopupTransition = forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} timeout={200} {...props} />;
});

const Dialog = ({
  isOpen,
  handleClose,
  handleToggleVisibility,
  title,
  content,
  okBtnText,
  cancelBtnText,
  okSubmitHandle,
  cancelSubmitHandle,
  children,
  loading = false,
  isOkBtnDisable,
  dialogSx,
  singleProjectToggle,
}) => {
  return (
    <MuiDialog
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={PopupTransition}
      aria-labelledby="dialog compoent"
      aria-describedby="show dialog component"
      scroll="paper"
      maxWidth="md"
      sx={{ ...dialogSx }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "primary.main",
          textTransform: "capitalize",
        }}
      >
        <Typography fontWeight={500}>{title}</Typography>
        <Stack direction={"row"} gap={3}>
          {handleToggleVisibility && (
            <IconButton
              onClick={handleToggleVisibility}
              sx={{ color: "primary.mainLight", mr: "-8px" }}
            >
              {singleProjectToggle ? <IconEye /> : <IconEyeOff />}
            </IconButton>
          )}
          <IconButton
            onClick={handleClose}
            sx={{ color: "primary.mainLight", mr: "-8px" }}
          >
            {handleClose && <IconSquareRoundedX />}
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: "1rem !important" }}>
        {content && (
          <DialogContentText sx={{ mb: 2 }}>{content}</DialogContentText>
        )}
        {children}
      </DialogContent>
      <DialogActions sx={{ px: "1.5rem", pb: "1.5rem" }}>
        {!!cancelBtnText && (
          <Button
            color="error"
            variant="outlined"
            onClick={cancelSubmitHandle}
            sx={{
              width: "10rem",
              height: "2rem",
              borderRadius: "6px",
            }}
          >
            {cancelBtnText}
          </Button>
        )}
        {!!okBtnText && (
          <Button
            disabled={isOkBtnDisable}
            variant="contained"
            onClick={okSubmitHandle}
            sx={{
              // width: '12rem',
              height: "2rem",
              borderRadius: "6px",
              ":hover": {
                border: "1px solid grey",
                bgcolor: "white",
                color: "primary.main",
              },
            }}
          >
            {okBtnText}
          </Button>
        )}
      </DialogActions>
    </MuiDialog>
  );
};

Dialog.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.any,
  okBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  okSubmitHandle: PropTypes.func,
  cancelSubmitHandle: PropTypes.func,
  children: PropTypes.node,
  loading: PropTypes.bool,
  isOkBtnDisable: PropTypes.bool,
  dialogSx: PropTypes.object,
  handleToggleVisibility: PropTypes.func,
  singleProjectToggle: PropTypes.bool,
};

export default Dialog;
